import { type Placement } from '@floating-ui/react-dom';

import { Tooltip, TooltipLabel } from '../Tooltip';
import Button, { ButtonProps } from './Button';

export type ButtonWTipProps<ID extends string = string> = ButtonProps<ID> & {
  tooltip?: TooltipLabel;
  tooltipPlacement?: Placement;
};
export default function ButtonWTip<ID extends string = string>({
  type,
  tooltip,
  tooltipPlacement,
  ...props
}: ButtonWTipProps<ID>) {
  return (
    <Tooltip
      background={type === 'reset' ? 'rgb(215, 39, 65)' : undefined}
      label={tooltip}
      placement={tooltipPlacement}
      autoPlace={tooltipPlacement != null ? false : true}>
      <Button {...props} type={type} />
    </Tooltip>
  );
}
